import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message_area" }
const _hoisted_2 = { class: "message_card" }
const _hoisted_3 = { class: "box_img_message" }
const _hoisted_4 = { class: "thumb_product badge_state" }
const _hoisted_5 = { class: "box_message" }
const _hoisted_6 = { class: "desc_message" }
const _hoisted_7 = { class: "sender" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.productImageUrl,
            class: "img_product",
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.message), 1)
        ]),
        _createVNode("span", _hoisted_7, "From. " + _toDisplayString(_ctx.ordererName), 1)
      ])
    ])
  ]))
}